let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("23kVC")).then(() => parcelRequire('3q6Cy'));